import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserManagementState } from '../reducers/user-management.reducer';
import { USER_MANAGEMENT_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<UserManagementState>(USER_MANAGEMENT_FEATURE_KEY);

export const selectSaved = createSelector(selectState, (state: UserManagementState) => state.saved);
export const selectSaving = createSelector(selectState, (state: UserManagementState) => state.saving);
